import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { ButtonLink } from '../ui/ButtonLink';
import { ReviewNote } from '../ui/ReviewNote';
const reasons = [{
  title: 'Established Botswana business',
  text: 'Incorporated in May 2007 under the Companies Registration Act and 100% citizen-owned, with its head office in Gaborone.'
}, {
  title: 'Multi-disciplinary capability',
  text: 'Roadworks, civil works, water and wastewater, building and structural works, stormwater and paving are all part of the documented service offering.'
}, {
  title: 'Experience across project types',
  text: 'Project references include government ministries, Water Utilities Corporation, Debswana, Botswana Railways and private developers.'
}, {
  title: 'Plant and equipment resources',
  text: 'Graders, an excavator, a vibro roller, backhoe loaders, water bowsers, trucks and support vehicles appear in the company plant schedule.'
}, {
  title: 'Registered for public procurement',
  text: 'Listed PPADB registration across building, civil engineering and water engineering codes, plus Debswana vendor registration.'
}, {
  title: 'Structured project delivery',
  text: 'Defined project manager, site agent, surveyor and SHE roles, with documented QA procedures for inspections, testing, records and as-built drawings.'
}];
export function WhyLiftoff() {
  return <section aria-labelledby="why-title" className="bg-charcoal py-20 md:py-28" data-id="element-227" data-mp="1t1urcj1gh9pb">
      <div className="mx-auto grid max-w-site gap-12 px-5 md:px-8 lg:grid-cols-12 lg:gap-16" data-id="element-228" data-mp="1xtmgqq8vl9dv">
        <div className="lg:col-span-5" data-id="element-229" data-mp="1j586hu94qina">
          <SectionHeading id="why-title" label="Why Liftoff" title="Why work with Liftoff Investments" intro="What procurement teams and project owners can check against the company profile." data-id="element-230" data-mp="1j69sgtroopjs" />
          <ButtonLink to="/about/registrations-procurement" variant="outline" showArrow className="mt-10" data-id="element-231" data-mp="1f3d9h1y8erfb">
            Registrations & Procurement
          </ButtonLink>
          <ReviewNote className="mt-8" data-id="element-232" data-mp="3gtvgh9k65cub">
            These points are drawn only from the October 2026 profile. Confirm that PPADB registrations are still valid
            before launch.
          </ReviewNote>
        </div>
        <dl className="border-t border-white/15 lg:col-span-7" data-id="element-233" data-mp="3315w19kagfzb">
          {reasons.map(reason => <div key={reason.title} className="grid gap-2 border-b border-white/15 py-6 sm:grid-cols-[240px_1fr] sm:gap-8" data-id="element-234" data-mp="3m0r7irvosrz">
              <dt className="flex items-start gap-3 font-display text-[21px] font-bold uppercase leading-[1.05] text-white" data-id="element-235" data-mp="3ut3jyend774b">
                <span className="mt-2 h-2 w-2 shrink-0 bg-brand-red" aria-hidden="true" data-id="element-236" data-mp="3qsbb3mien48k" />
                {reason.title}
              </dt>
              <dd className="text-[16px] leading-relaxed text-steel-300" data-id="element-237" data-mp="2fbkzfnv7pk7k">{reason.text}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}